import baseConfig from '~/baseConfig'
export default {
    baseUrl: baseConfig.projectConfig[process.env.VUE_APP_PROJECT_NAME].apis[process.env.VUE_APP_API_ENV][1],
    get(url, params) {
        return axios.get(this.baseUrl + url, params)
    },
    post(url, params) {
        return axios.post(this.baseUrl + url, params)
    }
}